import { useCallback } from 'react';

import { useLanguage } from '../../contexts/lang/languageContext';

import { useTenantSlug } from '~/features/tenant/helpers';
import { LocalizationService } from '~/services/api/localization/endpoints';
import { useIntakeChannel } from '~/slices/intakeChannelSlice';

export const useLocalizedCaseManagerFieldData = () => {
  const slug = useTenantSlug();
  const { selectedLanguage } = useLanguage();
  const selectedChannel = useIntakeChannel().intakeChannelData.selectedChannel;
  const localizedCaseManagerFieldQuery =
    LocalizationService.endpoints.caseManagerFields.useQuery(
      {
        selectedChannel: selectedChannel ?? 0,
        slug: slug,
      },
      { skip: !slug || !selectedChannel },
    );

  const getLocalizedCaseManagerFieldTitle = useCallback(
    (title: string, translate = '') => {
      if (!localizedCaseManagerFieldQuery.isSuccess) return title;

      if (translate === 'original') {
        let translation: { title: string; } = { title: '' };

        const itemFound = localizedCaseManagerFieldQuery.data.find((item) => {
          translation = item.translations[selectedLanguage.code];
          if (!translation) return false;

          return translation.title === title;
        });

        if (!itemFound) return title;

        return itemFound.title;
      } else {
        const itemFound = localizedCaseManagerFieldQuery.data.find((item) => {
          const translation = item.translations[selectedLanguage.code];
          if (!translation) return false;

          return item.title === title;
        });

        if (itemFound) {
          const translation = itemFound.translations[selectedLanguage.code];
          return translation.title;
        } else return title;
      }
    },
    [
      localizedCaseManagerFieldQuery.data,
      localizedCaseManagerFieldQuery.isSuccess,
      selectedLanguage.code,
    ],
  );

  return { getLocalizedCaseManagerFieldTitle };
};
